export const TYPE_LOCAL = [
    { label: 'Casa', value: 'House' },
    { label: 'Rua', value: 'Street' },
    { label: 'Comunidade', value: 'Community' },
    { label: 'Bairro', value: 'Neighborhood' },
    { label: 'Condomínio/Prédio', value: 'Condominium_Building'}
];